import {
    initSingleEnquiryFormPopupStates,
    initSingleExpertContactForm,
    initSupplierContactForm,
    initProductSliderEnquiryPopupButtons,
} from "./single-helpers";

declare const jQuery: any;
const $ = jQuery;

export function initSupplierSingle(): void
{
    if (!$(document.body).hasClass("single-supplier"))
    {
        return;
    }

    initSingleEnquiryFormPopupStates();
    initSingleExpertContactForm();
    initSupplierContactForm();
    initProductSliderEnquiryPopupButtons();
}
